import * as React from "react";
import { IPricing } from "src/services/interfaces/calculator/IPricing";
import { formatDate } from "src/util/formatDate";

export const PricingResultDate = (props: { pricing: IPricing }) => (

  <>
    <span className="subtitle">Datas</span>
    <div className="region-container">

      <div className="row">
        <span className="left description">Data Base:</span>
        <span className="right description">{formatDate(props.pricing?.baseDate)}</span>
      </div>
      <div className="row">
        <span className="left description">Data de Expedição:</span>
        <span className="right description">{formatDate(props.pricing?.issueDate)}</span>
      </div>
      <div className="row">
        <span className="left description">Valor de oferta sujeito a analise do precatorio</span>
        <span className="right description" />
      </div>
    </div>
  </>
)


// WEBPACK FOOTER //
// ./src/components/common/pricing-result/PricingResultDate.tsx